import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { fetchPostageAccountDetails, updatePostageAccount, reviewWorktagChangeRequest } from '../services/api';
import { useUser } from '../context/UserContext';
import Button from 'react-bootstrap/Button';

function WorktagChangeRequest() {
    const { postageAccountNumber } = useParams();
    const navigate = useNavigate();
    const { user } = useUser();
    const [account, setAccount] = useState({
        department: '',
        worktagString: '',
        worktagChangeRequest: '',
        comments: '',
        activeStatus: true
    });
    const [tempWorktagChange, setTempWorktagChange] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isOwner, setIsOwner] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPostageAccountDetails(postageAccountNumber)
            .then(data => {
                setAccount({ ...data, worktagString: data.worktagString }); // Convert array to string for display
                setIsAuthorized(data.authorizedUsers.some(au => au.netId == user.netId));
                setIsOwner(user?.accountLevel == 2 || user?.netId == data.owner.netId);
                setLoading(false); // Loading is complete
            })
            .catch(error => {
                console.error('Failed to fetch account details:', error);
                setError('Failed to fetch account details');
                setLoading(false);
            });
    }, [postageAccountNumber, user]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!isAuthorized && !isOwner && !loading) {
        return <Navigate to="/unauthorized" />;
    }

    const handleChange = (e) => {
        setTempWorktagChange(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const updateData = {
                ...account,
                worktagString: account.worktagString,
                worktagChangeRequest: tempWorktagChange
            };
            await updatePostageAccount(postageAccountNumber, updateData);
            setSuccess("Worktag String Change Request successfully submitted.");
            navigate(`/postage-account/${postageAccountNumber}`);
        } catch (error) {
            console.error('Failed to submit worktag change request:', error);
            setError('Failed to submit worktag change request: ' + error.message);
        }
    };

    const approveRequest = async () => {
        try {
            const approval = {
                approve: true
            };
            await reviewWorktagChangeRequest(postageAccountNumber, approval);
            setSuccess('Worktag String Change Request approved successfully.');
            navigate(`/postage-account/${postageAccountNumber}`);
        }
        catch (error) {
            console.error('Approval Failed');
            setError('Worktag Change Approval failed: ' + error.message);
        }
    };

    const denyRequest = async () => {
        try {
            const approval = {
                approve: false
            };
            await reviewWorktagChangeRequest(postageAccountNumber, approval);
            setSuccess('Worktag String Change Request denied successfully.');
            navigate(`/postage-account/${postageAccountNumber}`);
        }
        catch (error) {
            console.error('Approval Failed');
            setError('Worktag Change Approval failed: ' + error.message);
        }
    };

    const handleBack = () => {
        navigate(`/postage-account/${postageAccountNumber}`);
    }

    const worktagToChange = account.worktagChangeRequest?.length > 0 ? true : false;

    return (
        <div className="container">
            <h1>Worktag Change Request</h1>
            {(worktagToChange && !isOwner) && (
                <div>
                    <p>A pending Worktag Change Request is awaiting approval.</p>
                    <label htmlFor="worktagString" className="form-label">Current Worktag String Change Request</label>
                    <input type="text" className="form-control" id="worktagStringExistingRequest" name="worktagStringExistingRequest" value={account.worktagChangeRequest || ''} readOnly />
                </div>
            )}
            {(!worktagToChange && isAuthorized) && (
                <div>
                    <p>Request a change to the Worktag String used on this postage account.</p>
                    <div className="mb-3">
                        <label htmlFor="worktagString" className="form-label">Current Worktag String</label>
                        <input type="text" className="form-control" id="worktagString" name="worktagString" value={account.worktagString} readOnly />
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="worktagString" className="form-label">Requested New Worktag String</label>
                            <input type="text" className="form-control mb-4" id="worktagChangeRequest" defaultValue={account.worktagChangeRequest || ''} name="worktagChangeRequest" onChange={handleChange} />
                            <button type="submit" className="btn btn-primary">Update</button>
                        </div>
                    </form>
                </div>
            )}
            {isOwner && (
                <div>
                    <p>Approve or Deny a requested change to the Worktag String on this postage account.</p>
                    {!worktagToChange && (
                        <div>
                            <p><em>There is no pending change request</em></p>
                            <Button onClick={handleBack} className='me-2 btn-success'>Return to Postage Account</Button>
                        </div>
                    )}
                    {worktagToChange && (
                        <div>
                            <p>The requested <b>new</b> Worktag String is: {account.worktagChangeRequest}</p>
                            <Button onClick={() => approveRequest()} className="me-2 btn-success" aria-controls="approveWorktagChange">Approve Change</Button>
                            <Button onClick={() => denyRequest()} className="me-2 btn-danger" aria-controls="approveWorktagChange">Deny Change</Button>
                        </div>
                    )}

                </div>
            )}
        </div>
    );
}

export default WorktagChangeRequest;
